import type { User } from "@/users/types";
import type { Ref } from "vue";

const permissions = {
  canvasses: ["Admin", "Coordinator"],
  contacts: ["Admin", "Coordinator"],
  canvassFlowContacts: ["Admin", "Coordinator", "Member"],
  areas: ["Admin", "Coordinator"],
  houses: ["Admin", "Coordinator"],
  users: ["Admin"],
  settings: ["Admin"],
  stats: ["Admin", "Coordinator"],
  export: ["Admin"],
  earlyAccessBadge: ["Admin", "Coordinator"],
};

export type Feature = keyof typeof permissions;

export function usePermissions(me: Ref<User | undefined>) {
  const canAccess = (feature: Feature): boolean => {
    if (me.value === undefined) return false;
    return permissions[feature].includes(me.value.role);
  };

  return { canAccess };
}
